import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateFormTemplate = ({
  Show,
  Hide,
  Title,
  getStudyFormTemplatesData,
  templateData,
  studyId,
}) => {
  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [type, setType] = useState("");
  const [permissionType, setPermissionType] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (templateData) {
      setName(templateData?.name || "");
      setLabel(templateData?.label || "");
      setType(templateData?.type || "");
      setPermissionType(templateData?.permission || "");
    }
  }, [templateData]);

  const updateStudyFormTemplates = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this template?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = templateData?._id;
        userData.formId = templateData?.formId;
        userData.studyId = studyId;
        userData.name = name;
        userData.label = label;
        userData.type = type;
        userData.permission = permissionType;
        let data = await cdiscManagementService.updateStudyFormTemplates(userData);
        if (data?.statusCode === 200) {
          getStudyFormTemplatesData();
          Hide();
          setName("");
          setLabel("");
          setType("");
          setPermissionType("");
        }
        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Label <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            placeholder="Enter Label"
          />
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Type <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select onChange={(e) => setType(e.target.value)}>
            <option value="">Select Type</option>
            <option selected={type === "text"} value="text">
              Text
            </option>
            <option selected={type === "number"} value="number">
              Number
            </option>
            <option selected={type === "date"} value="date">
              Date
            </option>
            <option selected={type === "time"} value="time">
              Time
            </option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">
            Permission Type <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select onChange={(e) => setPermissionType(e.target.value)}>
            <option value="">Select Permission Type</option>
            <option selected={permissionType === "require"} value="require">
              Require
            </option>
            <option selected={permissionType === "expected"} value="expected">
              Expected
            </option>
            <option
              selected={permissionType === "permissible"}
              value="permissible"
            >
              Permissible
            </option>
          </Form.Select>
        </Form.Group>
      </Offcanvas.Body>

      <div className="text-end p-2 border-top">
        <button
          onClick={updateStudyFormTemplates}
          className="updateProfile"
          disabled={buttonLoader || !name || !label || !type || !permissionType}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateFormTemplate;
